'use client';
import { type FormControlChangeEventHandler } from '@curology/ui-components-web';
import {
  TextInput,
  type TextInputProps,
} from '@curology/ui-components-web/react/TextInput';
import React, { useState } from 'react';
import { type QuestionTextModel } from 'survey-core';

import { AnalyticsEvent, trackEvent } from '@/utils/analytics';

import { getErrorMessageFromValidators } from '../../utils/validation';

const Text = ({ question }: { question: QuestionTextModel }) => {
  const [errorState, setErrorState] = useState<TextInputProps['state']>('');
  const [helperText, setHelperText] = useState<string | null>('');

  const handleOnChange: FormControlChangeEventHandler = (event) => {
    question.value = event.target.value;
  };

  const handleOnBlur = () => {
    const errorMessage = getErrorMessageFromValidators(question);

    setErrorState(question.value === '' || errorMessage ? 'critical' : '');
    setHelperText(errorMessage);

    if (errorMessage) {
      trackEvent(AnalyticsEvent.INVALID_VALUE_ENTERED, {
        name: question.name,
        value: question.value,
      });
    }
  };

  return (
    <div role="presentation" className={'cur-pb-3'}>
      <TextInput
        helperText={helperText}
        label={question.getPropertyValue('title')}
        onBlur={handleOnBlur}
        onChange={handleOnChange}
        state={errorState}
        value={question.value ? question.value : ''}
      />
    </div>
  );
};

export default Text;
